import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { BehaviorSubject } from 'rxjs';
import { Lookup } from '../models/Lookup';

@Injectable({ providedIn: 'root' })
export class LookupsService {
  refreshList = new BehaviorSubject<boolean>(false);
  constructor(private http: HttpClient) {
  }

  GetMenu() {
    return this.http.get(`${environment.apiUrl}/Lookup/GetMenu`);
  }
  RestaurantsCountriesWeb() {
    return this.http.get(`${environment.apiUrl}/Lookup/RestaurantsCountriesWeb`);
  }
  getCountries() {
    return this.http.get(`${environment.apiUrl}/Lookup/CountriesWeb`);
  }
  getCities(countryId: number) {
    return this.http.get(`${environment.apiUrl}/Lookup/GetCitiesbyCountryId?CountryId=${countryId}`);
  }
  GetGender() {
    return this.http.get(`${environment.apiUrl}/Lookup/GetGender`);
  }
  getNationalities() {
    return this.http.get(`${environment.apiUrl}/Lookup/Nationalities`);
  }
  getSystems() {
    return this.http.get(`${environment.apiUrl}/Lookup/Systems`);
  }
  getRoles() {
    return this.http.get(`${environment.apiUrl}/Roles/list`);
  }
  DefaultCurrency() {
    return this.http.get(`${environment.apiUrl}/Lookup/DefaultCurrency`);
  }
  GetAllCurrencies() {
    return this.http.get(`${environment.apiUrl}/Lookup/GetAllCurrencies`);
  }
  PaymentMethods() {
    return this.http.get(`${environment.apiUrl}/Lookup/PaymentMethods`);
  }
  GetAllAmenities() {
    return this.http.get(`${environment.apiUrl}/Lookup/GetAllAmenitiesList`);
  }
  GetIngredients() {
    return this.http.get(`${environment.apiUrl}/Lookup/GetIngredients`);
  }
  RestaurantDefaultCurrency(restaurantId: any) {
    return this.http.get(`${environment.apiUrl}/Lookup/RestaurantDefaultCurrency?RestaurantId=${restaurantId}`);
  }
  GetTags() {
    return this.http.get(`${environment.apiUrl}/Lookup/GetTags`);
  }
  GetAllFoodAllergens() {
    return this.http.get<Lookup[]>(`${environment.apiUrl}/Lookup/GetAllFoodAllergens`);
  }
}
